import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { KernelSessionItem } from './KernelSessions';
import './kernelSessions.css';

const LimitIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <line x1="8" y1="20" x2="16" y2="20" />
    <line x1="12" y1="16" x2="12" y2="20" />
  </svg>
);

/**
 * Schermata del login quando l'utente ha già raggiunto il limite di accessi contemporanei: password e codice sono già
 * stati verificati, resta da scegliere quale accesso chiudere per far posto a questo.
 */
function KernelSessionLimit({ limit, sessions, busy, onChoose, onBack }) {
  const { t } = useLanguage();
  return (
    <div className="kernel-session-limit">
      <span className="kernel-session-limit-icon"><LimitIcon /></span>
      <h2>{t('sessions.limitTitle')}</h2>
      <p className="reset-hint">{t('sessions.limitHint', { limit })}</p>
      <ul className="kernel-session-list">
        {sessions.map((s) => (
          <KernelSessionItem key={s.sid} session={s} busy={busy} onClose={(row) => onChoose(row.sid)} closeLabel={t('sessions.closeAndEnter')} />
        ))}
      </ul>
      <button type="button" className="kernel-session-back" onClick={onBack} disabled={busy}>
        <span aria-hidden="true">←</span> {t('auth.otpBack')}
      </button>
    </div>
  );
}

export default KernelSessionLimit;
